import { createContext, useContext } from 'react';
import type { IssueIndex } from '../../domain/issues';
import type { BlockType, FlowDoc } from '../../domain/types';

/** O que está selecionado no canvas: um card, um bloco (dentro do card) ou uma ligação. */
export type Selection = { groupId: string; blockId?: string } | { edgeId: string } | null;

export const selectedGroupId = (s: Selection): string | null => (s && 'groupId' in s ? s.groupId : null);
export const selectedBlockId = (s: Selection): string | null =>
  s && 'groupId' in s ? (s.blockId ?? null) : null;
export const selectedEdgeId = (s: Selection): string | null => (s && 'edgeId' in s ? s.edgeId : null);

/** Tipo arrastado da paleta (`card` ou um tipo de bloco). */
export const DRAG_MIME = 'application/x-centuria-bloco';
export const CARD_DRAG = 'card';

export interface Builder {
  doc: FlowDoc;
  issues: IssueIndex;
  selection: Selection;
  select: (s: Selection) => void;
  update: (fn: (doc: FlowDoc) => FlowDoc) => void;
  /** Bloco novo no card (no fim ou em `index`), já selecionado para editar. */
  addBlock: (groupId: string, type: BlockType, index?: number) => void;
  /** Abre o painel de teste começando neste card. */
  testFrom: (groupId: string) => void;
}

export const BuilderContext = createContext<Builder | null>(null);

export function useBuilder(): Builder {
  const ctx = useContext(BuilderContext);
  if (!ctx) throw new Error('useBuilder fora do FlowEditor');
  return ctx;
}
